import { G_listShorthands } from "../../../utils/globals/shorthands";

/**
 * Get property shorthand
 * @param {String} input
 * @returns {String}
 */
const getPropertyShorthand = (input) => {
  if (input.length < 5) {
    if (G_listShorthands.has(input)) {
      return G_listShorthands.get(input) || "";
    } else {
      return input;
    }
  } else {
    return input
  }
}

export default getPropertyShorthand;